import type { HTMLAttributes } from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import type { SimpleEvent } from 'autogen/swagger/comai';
import BasicChips from './BasicChips';
import ErrorMessage from './ErrorMessage';
import ProblemSolverForm from './ProblemSolverForm';
import ProductList from './ProductList';

type ChipsRendererProps = HTMLAttributes<HTMLElement> & {
    chunk: SimpleEvent;
};

export function MetadataRenderer(props: ChipsRendererProps) {
    const { chunk, className } = props;

    switch (chunk.custom_metadata?.metadata_type) {
        case 'chips':
            return (
                <BasicChips chips={chunk.custom_metadata.chips} key={chunk.id} hideWhenClicked className={className} />
            );
        case 'product_carousel':
            return <ProductList products={chunk.custom_metadata.products} key={chunk.id} className={className} />;
        case 'problem_solver_form':
            return (
                <ProblemSolverForm
                    statements={chunk.custom_metadata.statements}
                    choices={chunk.custom_metadata.choices}
                    key={chunk.id}
                    className={className}
                />
            );
        default:
            return null;
    }
}

export default withErrorBoundary(MetadataRenderer, {
    fallback: <ErrorMessage />
});
